import "./Index.module.scss";
import logo from "./lumlogo.svg";

import React from "react";
import {injectIntl, IntlShape} from "react-intl";
import {Link} from "react-router-dom";

import SessionCheck from "@/SessionCheck";
import {intl2Str} from "@translate/T";
import Help from "./Help";
import Languages from "./Languages";
import NavLinks from "./NavLinks";
import Profile from "./Profile";
import Queue from "./queue/Index";

interface INavBarProps {
    intl: IntlShape;
}

class NavBar extends React.PureComponent<INavBarProps> {
    public render() {
        const {intl} = this.props;

        return (
            <header id="app-header" className="mb-2">
                <nav
                    id="nav-bar"
                    className="navbar navbar-expand-lg navbar-light bg-light" // same as TasksPanel.tsx
                    // navbar-expand does fancy flex and dropdown button otherwise
                    // navbar-light does changes text to black (links would be green otherwise)
                    // bg-light does add some background color, would be transparent otherwise
                >
                    <Link className="navbar-brand" to="/">
                        <img
                            id="nav-logo"
                            styleName="nav-logo"
                            alt={intl2Str(intl, "LUM logo")}
                            src={logo}
                        />
                    </Link>
                    <Link
                        id="nav-sepview"
                        className="navbar-brand mb-0 mr-2"
                        to="/"
                    >
                        SEPView
                    </Link>

                    <button
                        type="button"
                        className="navbar-toggler"
                        aria-controls="navbar"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        data-target="#navbar"
                        data-toggle="collapse"
                    >
                        <span className="navbar-toggler-icon" />
                    </button>

                    <div id="navbar" className="collapse navbar-collapse">
                        <NavLinks />

                        <ul className="navbar-nav">
                            <SessionCheck>
                                <Queue />
                            </SessionCheck>
                            <Help />
                            <Languages />
                            <SessionCheck>
                                <Profile />
                            </SessionCheck>
                        </ul>
                    </div>
                </nav>
            </header>
        );
    }
}

export default injectIntl(NavBar);
